(() => {
  if (window.eleatCartActionFeedback) return;

  const legacySelector = [
    '.cart-aside__item-delete', '.cart-aside__bundle-item-delete',
    '.quantity__minus', '.quantity__plus', '.recomended__add-to-cart',
    '.type-button', '.type-subscriptions__plans', '.variant-select'
  ].join(',');
  const explicitSelector = '[data-js-subscription-upgrade-toggle], [data-eleat-edit-bundle], [data-eleat-cart-upsell]';
  const checkoutSelector = '[name="checkout"], a[href="/checkout"]';
  const actionSelector = [legacySelector, explicitSelector, checkoutSelector].join(',');
  const loadingSelector = '.cart-aside__header.loading, .cart-aside__items.loading, .cart-aside__footer.loading, .cart-aside__recomended-container.loading';
  const navigationTimeoutMs = 30000;
  let active = null;
  let drawer = null;
  let status = null;

  const restoreAttribute = (node, name, value) => {
    if (value === null) node.removeAttribute(name);
    else node.setAttribute(name, value);
  };

  function finish(button, options = {}) {
    if (!active || (button && active.button !== button)) return;
    const state = active;
    active = null;
    clearTimeout(state.navigationTimer);
    state.navigationObserver?.disconnect();
    if (state.navigationListener) document.removeEventListener('olStateChanged', state.navigationListener);
    state.spinner.remove();
    state.button.classList.remove('eleat-cart-action-pending');
    restoreAttribute(state.button, 'aria-busy', state.busy);
    restoreAttribute(state.button, 'aria-disabled', state.ariaDisabled);
    if ('disabled' in state.button) state.button.disabled = options.keepDisabled || state.disabled;
    drawer?.removeAttribute('data-eleat-cart-action-pending');
    if (status) status.textContent = options.navigationCancelled
      ? 'Checkout did not open. Please review your cart and try again.'
      : options.error ? 'Cart update failed. Please check the message in your cart.' : 'Cart updated.';
  }

  function checkoutValidationVisible() {
    // OrderLogic uses SweetAlert 1.1.3 with this app-specific custom class.
    const modal = document.querySelector('.sweet-alert.order-logic-sweet-alert.visible');
    return Boolean(modal && modal.getClientRects().length && getComputedStyle(modal).visibility !== 'hidden');
  }

  function checkoutRequestPending() {
    const states = window.OL_STATES;
    return Boolean(drawer?.querySelector(loadingSelector) || (states && (
      window.ol_current_state === states.LOADING || window.ol_current_state === states.CHECKING
    )));
  }

  function watchNavigation(state) {
    const recoverIfBlocked = () => {
      if (active !== state || state.mode !== 'navigation') return;
      if (checkoutValidationVisible()) state.sawCheckoutValidation = true;
      if (state.sawCheckoutValidation && !checkoutRequestPending()) {
        finish(state.button, { navigationCancelled: true });
      }
    };
    state.navigationListener = recoverIfBlocked;
    document.addEventListener('olStateChanged', recoverIfBlocked);
    // The app appends its dialog outside the drawer, so the drawer observer cannot see it.
    state.navigationObserver = new MutationObserver(recoverIfBlocked);
    state.navigationObserver.observe(document.body, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden']
    });
    const recoverIfStalled = () => {
      if (active !== state || state.mode !== 'navigation') return;
      // Never time out a cart mutation or the validator's active check.
      // Explicit promise-owned actions do not enter this watchdog at all.
      if (document.hidden || checkoutRequestPending()) {
        state.navigationTimer = setTimeout(recoverIfStalled, 1000);
        return;
      }
      finish(state.button, { navigationCancelled: true });
    };
    state.navigationTimer = setTimeout(recoverIfStalled, navigationTimeoutMs);
    queueMicrotask(recoverIfBlocked);
  }

  function begin(button, mode = 'explicit') {
    if (!button || active || button.disabled || button.getAttribute('aria-disabled') === 'true') return false;
    const spinner = document.createElement('span');
    spinner.className = 'eleat-cart-action-spinner';
    spinner.setAttribute('aria-hidden', 'true');
    active = {
      button, spinner, mode, sawLoading: false,
      disabled: Boolean(button.disabled),
      busy: button.getAttribute('aria-busy'),
      ariaDisabled: button.getAttribute('aria-disabled')
    };
    button.classList.add('eleat-cart-action-pending');
    button.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-disabled', 'true');
    if (button.tagName === 'SELECT') button.insertAdjacentElement('afterend', spinner);
    else button.append(spinner);
    drawer?.setAttribute('data-eleat-cart-action-pending', 'true');
    if (status) status.textContent = mode === 'navigation' ? 'Opening checkout…' : 'Updating your cart…';
    // Let the existing click/change handler run before disabling its native control.
    const state = active;
    if (mode === 'navigation') watchNavigation(state);
    queueMicrotask(() => {
      if (active === state && 'disabled' in button) button.disabled = true;
    });
    return true;
  }

  window.eleatCartActionFeedback = { begin, finish };

  function syncLegacyState() {
    if (!drawer) return;
    // The compiled theme writes this GIF only while its request is pending.
    drawer.querySelectorAll('.cart-aside__body-loading-message img[src*="Eleat-Loading-Animation-Cirlce.gif"]').forEach(image => {
      const spinner = document.createElement('span');
      spinner.className = 'eleat-cart-loading-spinner';
      spinner.setAttribute('aria-hidden', 'true');
      image.replaceWith(spinner);
    });
    if (!active || active.mode !== 'legacy') return;
    const loading = drawer.querySelector(loadingSelector);
    if (loading) active.sawLoading = true;
    else if (active.sawLoading) {
      const error = drawer.querySelector('.cart-aside__body-loading-message circle[fill="#DE3B39"]');
      finish(active.button, { error: Boolean(error) });
    }
  }


  let checkoutPassthrough = null;
  const cartRoot = () => window.Shopify?.routes?.root || '/';
  const trialPackProductIds = new Set([15762254659967, 15196799435135]);
  const isCartTrialPack = item => item.quantity > 0 && item.properties?._eleat_cart_upsell === 'true' && trialPackProductIds.has(Number(item.product_id));

  async function cartRequest(path, body) {
    const response = await fetch(cartRoot() + path, body ? {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    } : { cache: 'no-store' });
    const result = await response.json();
    if (!response.ok || result.description || Number(result.status) >= 400) {
      throw new Error(result.description || result.message || String(response.status));
    }
    return result;
  }

  function offerCopy(name) {
    return drawer?.querySelector('upsell-swiper')?.dataset[name] || '';
  }

  function showOfferError(message) {
    let notice = drawer?.querySelector('.eleat-cart-offer-error');
    if (!notice) {
      notice = document.createElement('p');
      notice.className = 'eleat-cart-offer-error px-4 py-2 text-small';
      notice.setAttribute('role', 'alert');
      drawer?.querySelector('.cart-aside__body')?.prepend(notice);
    }
    notice.textContent = message;
  }

  function refreshOfferCart(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const incoming = parsed.querySelector('.cart-aside');
    if (!incoming?.querySelector('.cart-aside__items')) throw new Error('Cart section missing');
    for (const selector of ['.cart-aside__header-count', '.cart-progress', '.cart-aside__items', '.cart-aside__prices', '.cart-aside__recomended-container']) {
      const source = incoming.querySelector(selector);
      const destination = drawer.querySelector(selector);
      if (source && destination) destination.innerHTML = source.innerHTML;
    }
    window.setUpCart?.();
  }

  async function addCartOffer(button) {
    if (!begin(button)) return;
    const addError = offerCopy('addError');
    const refreshError = offerCopy('refreshError');
    let added = false;
    try {
      drawer.querySelector('.eleat-cart-offer-error')?.remove();
      const addedOffer = await cartRequest('cart/add.js', { items: [{
        id: button.dataset.variantId, quantity: Number(button.dataset.quantity) || 1,
        properties: { _eleat_cart_upsell: 'true' }
      }] });
      added = true;
      const updated = await cartRequest('cart/update.js', {
        attributes: {
          eleat_cart_upsell: 'accepted',
          ...((addedOffer.items || [addedOffer]).some(item => trialPackProductIds.has(Number(item.product_id)))
            ? { eleat_cart_trial_upsell: 'accepted' } : {})
        },
        sections: ['cart-aside'], sections_url: window.location.pathname
      });
      refreshOfferCart(updated.sections?.['cart-aside'] || '');
      finish(button);
    } catch (error) {
      finish(button, { error: true, keepDisabled: added });
      showOfferError(added ? refreshError : addError);
    }
  }

  async function prepareOfferCheckout(button) {
    if (!begin(button)) return;
    const checkoutError = offerCopy('checkoutError');
    try {
      const cart = await cartRequest('cart.js');
      const accepted = cart.items.some(item => item.quantity > 0 && item.properties?._eleat_cart_upsell === 'true');
      const marker = accepted ? 'accepted' : '';
      const trialMarker = cart.items.some(isCartTrialPack) ? 'accepted' : '';
      const attributes = { eleat_cart_upsell: marker, eleat_cart_trial_upsell: trialMarker };
      if (Object.entries(attributes).some(([key, value]) => (cart.attributes?.[key] || '') !== value)) {
        await cartRequest('cart/update.js', { attributes });
      }
      finish(button);
      checkoutPassthrough = button;
      button.click();
    } catch (error) {
      finish(button, { error: true });
      showOfferError(checkoutError);
    }
  }

  function capture(event) {
    const button = event.target.closest?.(actionSelector);
    if (!button || !button.closest('.cart-aside')) return;
    if (event.type === 'click' && (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) return;
    if (active) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    if (event.type === 'click' && button.matches('[data-eleat-cart-upsell]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      void addCartOffer(button);
      return;
    }
    if (event.type === 'click' && button.matches(checkoutSelector)) {
      if (checkoutPassthrough === button) checkoutPassthrough = null;
      else {
        event.preventDefault();
        event.stopImmediatePropagation();
        void prepareOfferCheckout(button);
        return;
      }
    }
    if (button.matches(explicitSelector)) return; // These handlers own their promises.
    if (event.type === 'click' && button.tagName === 'SELECT') return;
    if (event.type === 'change' && button.tagName !== 'SELECT') return;
    if (button.matches('.quantity__minus') && Number(button.closest('.cart-aside__item-quantity')?.querySelector('.quantity__value')?.value) <= 0) return;
    begin(button, button.matches(checkoutSelector) ? 'navigation' : 'legacy');
  }

  function ready() {
    drawer = document.querySelector('.cart-aside');
    if (!drawer) return;
    status = document.createElement('span');
    status.className = 'eleat-cart-action-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    drawer.append(status);
    new MutationObserver(syncLegacyState).observe(drawer, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['class']
    });
    document.addEventListener('click', capture, true);
    document.addEventListener('change', capture, true);
    syncLegacyState();
  }

  window.addEventListener('pagehide', () => finish());
  window.addEventListener('pageshow', event => { if (event.persisted) finish(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
})();
